






















































































































































import Vue from "vue";
import store from "../services/RiportStore";
import eventBus from "@/services/eventBus";
import LookupComboBox from "@/modules/transactions/components/LookupComboBox.vue";

const LIST_ROUTE = "/riport-definitions";

export default Vue.extend({
  components: { LookupComboBox },
  data() {
    return {
      store,
      level: "" as string,
      isNew: false,
      model: {} as any,
      busy: false,
    };
  },
  computed: {
    title(): string {
      const labels: Record<string, string> = {
        head: "riport fej",
        maingroup: "főcsoport",
        group: "csoport",
        row: "sor",
        rowitem: "sortétel",
        mainitem: "elem",
      };
      return (this.isNew ? "Új " : "Szerkesztés – ") + (labels[this.level] || "");
    },
    // "Élő" switch: a soft-delete (deleted) mező inverze. true = élő, false = törölt (live_dead).
    // (A mainitem/"elem" táblán nincs live_dead → ott nincs ez a switch.)
    isLive: {
      get(): boolean { return !this.model.deleted; },
      set(v: boolean) { this.model.deleted = !v; },
    },
    yearItems(): any[] {
      return this.store.years.map((y: any) => ({ id: y.id, label: y.name || String(y.year) }));
    },
    // Az "elem" hivatkozás-legördülői: a fej csomópontjai + egy "— (nincs)" (id=1) opció.
    refMainGroupItems(): any[] {
      return [{ id: 1, name: "— (nincs)" }, ...this.store.mainGroups];
    },
    refGroupItems(): any[] {
      return [{ id: 1, name: "— (nincs)" }, ...this.store.allGroups];
    },
    refRowItems(): any[] {
      return [{ id: 1, name: "— (nincs)" }, ...this.store.allRows];
    },
    // A 9 dimenzió-slot LookupComboBox-aihoz: slot N → (N+1) típusú dimenziók (a tranzakciós dim1=2. típus mintára).
    dimsBySlot(): any[] {
      const map: any[] = [];
      for (let n = 1; n <= 9; n++) {
        map[n] = this.store.dimensions.filter((d: any) => d.type === n + 1);
      }
      return map;
    },
  },
  created() {
    this.level = String(this.$route.params.level || "");
    this.isNew = this.$route.name === "RiportDefCreate";

    // Közvetlen URL / oldalfrissítés esetén nincs kontextus (kiválasztott szülő vagy a szerkesztett rekord) → vissza a listára.
    if (this.isNew) {
      if (!this.hasParentContext()) {
        this.$router.replace(LIST_ROUTE);
        return;
      }
    } else if (!this.store.editItem) {
      this.$router.replace(LIST_ROUTE);
      return;
    }
    this.initModel();
    // A sortétel maszkjaihoz töltsük be a riport évének dimenzióit és főkönyvi számait (ha még nincsenek).
    if (this.level === "rowitem") {
      if (!this.store.dimensions.length) this.store.loadDimensions();
      if (!this.store.accounts.length) this.store.loadAccounts();
    }
  },
  methods: {
    // Create-hez kell a szülő kontextus a store-ban (különben nincs honnan a parent FK / a lookupok).
    hasParentContext(): boolean {
      switch (this.level) {
        case "head": return !!this.store.selectedType;
        case "maingroup": return !!this.store.selectedHeadId;
        case "group": return !!this.store.selMainGroupId;
        case "row": return !!this.store.selGroupId;
        case "rowitem": return !!this.store.selRowId;
        case "mainitem": return !!this.store.selMainGroupId;
        default: return false;
      }
    },
    async save(): Promise<void> {
      this.busy = true;
      try {
        await this.store.persist(this.level, this.model);
        eventBus.$emit("success", "Sikeres mentés!");
        // A mentett szintet a store-ban frissítjük, hogy a lista visszatéréskor az új/módosított elemet mutassa.
        await this.store.reload(this.level);
        this.store.editItem = null;
        this.$router.push(LIST_ROUTE);
      } catch (e) {
        eventBus.$emit("error", "A mentés nem sikerült!");
      } finally {
        this.busy = false;
      }
    },
    // A model alapértékre állítása: edit → az eredeti (szerkesztetlen) rekord, create → blankModel (üres defaultok).
    initModel(): void {
      this.model = this.isNew
        ? this.store.blankModel(this.level)
        : (this.store.editItem ? { ...this.store.editItem } : {});
    },
    // "Mégse": NEM navigál vissza – elveti az eddigi módosításokat és visszatölti az alapértékeket (ha nincs alap, üres).
    cancel(): void {
      this.initModel();
    },
    // A dimenzió LookupComboBox értéke lehet kiválasztott objektum (.dimcode) vagy beírt egyedi maszk (string).
    onDimChange(n: number, newValue: any): void {
      const val = newValue && typeof newValue === "object" ? newValue.dimcode ?? "" : newValue ?? "";
      this.model["dimcode" + n] = val;
    },
    // A főkönyvi szám LookupComboBox értéke lehet kiválasztott objektum (.accno) vagy beírt egyedi maszk (string).
    onAccNoChange(newValue: any): void {
      const val = newValue && typeof newValue === "object" ? newValue.accno ?? "" : newValue ?? "";
      this.model.accNo = String(val);
    },
  },

});
